import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getAvailableSubscriptionServices = async (token, simId = null) => {
    log("welcome in getAvailableSubscriptionServices")

    if (!token || token === "") {
        alert("No token in getAvailableSubscriptionServices")
        return {error: true, message: "No token provided", services: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_available_subscription_services_api'
        if (simId) {
            url += `?sim_id=${simId}`
        }
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getAvailableSubscriptionServices")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getAvailableSubscriptionServices")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getAvailableSubscriptionServices", services: []}
    }
}

export const addImsiSubscription = async (token, data) => {
    log("welcome in addImsiSubscription")
    log("data:")
    log(data)

    if (!token || token === "") {
        return {error: true, message: "No token provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/add_imsi_subscription_api'
        log("url=" + url)

        const payload = {
            sim_id: data.sim_id,
            service_id: data.service_id,
            autorenew: data.autorenew || false,
            seria_echipament: data.seria_echipament || null,
            nui: data.nui || null,
            technician: data.technician || null
        }

        const result = await axios.post(url, payload, {headers: headers})
        log("result.data din axios addImsiSubscription")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in addImsiSubscription")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la addImsiSubscription"}
    }
}

const useSubscriptionAPI = () => {
    return {error, getAvailableSubscriptionServices, addImsiSubscription}
}

export default useSubscriptionAPI
